__turbopack_context__.v({
  "className": "tungsten_1d9b7b7c-module__hGne9a__className",
});
